import { BaseAction } from "../../../core/actions/BaseAction";
import { ExecutionStatus } from "../../../core/enum/ExecutionStatus";
import { _eventBus } from "../../../core/events/EventBus";
import { getTranslatedMessage } from "../../../Lib/Utils/i18n";
import {
  ICMSBookNowParams,
} from "../../../Orchestrator/Types/Interface/ICmsDestination";
import { showNotification } from "../../../Services/notificationService";
import { getSearchResultAction } from "../../LogicActions/Search/GetSearchResultAction";
import { updateSearchDataForResumeAction } from "../Search/UpdateSearchDataForResumeAction";

class DestinationBookNowAction extends BaseAction<void, ICMSBookNowParams> {
  override async run(): Promise<void | null> {
    if (this.params) {
      const { search } = this.params;

      if (!search?.origin || !search?.destination) {
        showNotification("error", getTranslatedMessage('selectOriginDestination'), "");
      } else {
        await getSearchResultAction.setParams({ ...search });
        await getSearchResultAction.execute();
        if (getSearchResultAction.status.executionStatus == ExecutionStatus.SUCCESS) {
          const result = getSearchResultAction.result;

          if (result?.result == "true") {
            //Update searchStateAtom from Resume Search Data
            updateSearchDataForResumeAction.setParams({ ...search });
            await updateSearchDataForResumeAction.execute();
            localStorage.setItem("resumeSearch", JSON.stringify(search))

            
            // Set flag to identify user come from destination detail page
            sessionStorage.setItem('isFromDestinationDetail', "true")
            _eventBus.emit({
              eventName: "FLOW_CLOSE",
              data: `DestinationDetailFlow`,
            });
            _eventBus.emit({
              eventName: "FLOW_CLOSE",
              data: `DestinationsFlow`,
            });
            _eventBus.emit({
              eventName: "FLOW_CHANGE",
              data: "MainBookingFlow",
            });
            _eventBus.emit({
              eventName: "ROUTE_CHANGE",
              data: "/train-offer",
            });
          } else if (result?.result !== "shuttle") {
            // A hard search error (GetSearchResultAction's catch returns
            // result "false") would otherwise leave the click dead with no
            // feedback — surface it. ("No trains" already warns + still routes.)
            showNotification("error", getTranslatedMessage("noOffers"), getTranslatedMessage("selectDifferentSearch"));
          }
        } else {
          showNotification("error", getTranslatedMessage("noOffers"), getTranslatedMessage("selectDifferentSearch"));
        }
      }
    }
  }
}

export const destinationBookNowAction = new DestinationBookNowAction();
